import React, { useState } from "react"
import { Box, TableContainer } from "@mui/material"
import { useTranslation } from "react-i18next"
import { EMPLOYMENT_TYPE, Genders, USER_TYPES } from "src/modules/const"
import { useNavigate } from "react-router"
import { Tag, User } from "src/openapi"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import "./employee_table.scss"

interface Props {
  data: User[]
  tags: Tag[]
  companyId: number
}
export const EmployeeTable = ({ data, tags, companyId }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "employee" })

  const navigate = useNavigate()

  const [hoverIndex, setHoverIndex] = useState<number>()

  const idToTag = new Map(tags.map((tag) => [tag.id, tag.tag]))

  const calcAge = (date: string) => {
    let age = new Date().getFullYear() - new Date(date as string).getFullYear()
    return age.toString()
  }

  const calcPeriod = (joinDate: string) => {
    if (joinDate == null) return ""

    let now = new Date()
    let prev = new Date(joinDate as string)

    let months = (now.getFullYear() - prev.getFullYear()) * 12
    months -= prev.getMonth()
    months += now.getMonth()
    months = months <= 0 ? 0 : months

    let y = ""
    let m = ""
    if (months >= 12) {
      y = Math.round(months / 12).toString()
    } else {
      y = "0"
    }
    m = Number(months % 12).toString()
    return `(${y}${t("year")}${m}${t("months")})`
  }

  const getType = (type: string) => {
    let v = ""
    EMPLOYMENT_TYPE.forEach((t) => {
      if (type == t.value) {
        v = t.name
      }
    })
    return v
  }

  const getUserType = (userType: string) => {
    let v = ""
    USER_TYPES.forEach((t) => {
      if (userType === t.value) {
        v = t.name
      }
    })
    return v
  }

  return (
    <TableContainer
      style={{
        width: "100%",
        height: "calc(100vh - 180px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Table className="employee_table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "6%" }}>{t("ID")}</TableCell>
            <TableCell sx={{ width: "9%" }}>{t("name_well")}</TableCell>
            <TableCell sx={{ width: "9%" }}>{t("name_kana")}</TableCell>
            <TableCell sx={{ width: "6%" }}>{t("gender")}</TableCell>
            <TableCell sx={{ width: "4%" }}>{t("age")}</TableCell>
            <TableCell sx={{ width: "16%" }}>{t("email_address")}</TableCell>
            <TableCell sx={{ width: "8%" }}>{t("employment_type")}</TableCell>
            <TableCell sx={{ width: "8%" }}>{t("join_company_date")}</TableCell>
            <TableCell sx={{ width: "10%" }}>{t("tag")}</TableCell>
            <TableCell sx={{ width: "8%" }}>{t("user_type")}</TableCell>
            <TableCell sx={{ width: "6%" }}>{t("login")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length == 0 ? (
            <TableRow>
              <TableCell colSpan={10} sx={{ textAlign: "center" }}>
                {t("no_data")}
              </TableCell>
            </TableRow>
          ) : (
            data.map((row, index) => {
              return (
                <TableRow
                  key={`${row.id}`}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(undefined)}
                  className={`${index === hoverIndex ? "td-hover" : ""}`}
                  onClick={() => {
                    navigate(`/company/${companyId}/employee/detail/${row.id}`)
                  }}
                >
                  <TableCell>{row.employeeId}</TableCell>
                  <TableCell>{`${row.lastName} ${row.firstName}`}</TableCell>
                  <TableCell>{`${row.lastNameKana} ${row.firstNameKana}`}</TableCell>
                  <TableCell>
                    {row.gender == Genders.OTHER
                      ? row.genderComment
                      : row.gender == Genders.MALE
                        ? t("male")
                        : t("female")}
                  </TableCell>
                  <TableCell>{row.birthday ? calcAge(row.birthday!) : ""}</TableCell>
                  <TableCell>{row.email || ""}</TableCell>
                  <TableCell>{getType(row.employmentType!)}</TableCell>
                  <TableCell>{`${
                    row.joiningDate != null ? row.joiningDate?.substring(0, 7) : ""
                  } ${calcPeriod(row.joiningDate!)}`}</TableCell>
                  <TableCell>
                    <Box className="tag-label">
                      {(row.tagIds?.length || 0) === 0
                        ? ""
                        : row.tagIds?.map((id, index) => {
                            return (
                              <Box className="tag-box" key={`tag_${index}`}>
                                {idToTag.get(id)}
                              </Box>
                            )
                          })}
                    </Box>
                  </TableCell>
                  <TableCell>{getUserType(row.userType!)}</TableCell>
                  <TableCell sx={{ color: row.firstLoginStatus ? "" : "red !important" }}>
                    {row.firstLoginStatus ? t("done") : t("not_yet")}
                  </TableCell>
                </TableRow>
              )
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
